export default __webpack_public_path__ + "static/media/img_abdullah.6ce16083.png";